<template>
  <div class="LoginQR">
    <div class="TextBlock LoginLeft">
      <div class="Upper">
        Terminal entsperren!
      </div>
      <div class="Lower">
        Bitte scannen Sie den<br />
        <strong>QR-Code</strong><br />
        mit der MD-App ein.
      </div>
    </div>

    <div class="QRBlock">
      <img class="Image" v-bind:src="qrCode" />
    </div>

    <div class="TextBlock LoginRight">
      <div class="Upper">
        Unlock Terminal!
      </div>
      <div class="Lower">
        Please scan the<br />
        <strong>QR Code</strong><br />
        with the MD-App.
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LockedTerminal",
  props: {},
  data: function () {
    return {
      qrCode: "",
      qrTerminalTimeout: undefined,
    };
  },
  created: function () {},
  destroyed() {
    if (this.qrTerminalTimeout != undefined) {
      clearTimeout(this.qrTerminalTimeout);
    }
  },
  mounted: function () {
    this.RequestNew();
  },
  methods: {
    RequestNew: function () {
      let view = this;
      view.qrTerminalTimeout = setTimeout(function qrTerminal() {
        view.RequestTerminalQRCode();
        view.qrTerminalTimeout = setTimeout(qrTerminal, 300000);
      }, 0);
    },

    RequestTerminalQRCode: function () {
      let view = this;
      let url = "/api/getQRCodeForTerminal";
      view.$parent.LATEST_REQUEST = Date.now();
      axios({
        method: "get",
        headers: {},
        url: url,
      })
        .then((response) => {
          view.qrCode = response.data.image;
          view.$parent.prevTerminalId = view.$parent.tempTerminalId;
          view.$parent.tempTerminalId = response.data.terminalId;
          view.$parent.listenToUnlockTerminalChanged();
          view.$forceUpdate();
        })
        .catch(function (error) {
          if (error && error.response && error.response.status == 503) {
            if (error.response.data && error.response.data.type == "Maintenance") {
              view.$parent.MAINTENANCE = true;
            }
          }
          console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.LoginQR {
  background-color: #fff;
  width: 100%;
  height: 365px;
  overflow: hidden;
  display: grid;
  /* Das Grid sorgt für die Aufteilung: 1 Teil Links, max 254px Mitte, 1 Teil Rechts */
  grid-template-columns: 1fr minmax(150px, 254px) 1fr;
  grid-column-gap: 20px;
  column-gap: 20px; /* Ein moderater Abstand */
  box-sizing: border-box; 
  padding: 0 10px; 
}

/* Gemeinsame Stile für Textblöcke links & rechts */
.TextBlock {
  height: 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Vertikal zentriert */
}

/* Symmetrische Überschriften (Exakt 2 Zeilen) */
.Upper {
  font-family: DistrictProBold;
  color: #7f7f7f;
  font-size: 20px; 
  line-height: 30px; /* Etwas Luft zwischen den zwei Zeilen */
  margin-bottom: 25px; /* Abstand zwischen Titel und Text */
}

/* Symmetrische Anleitungen (Exakt 3 Zeilen) */
.Lower {
  font-family: DistrictProBook;
  color: #7f7f7f;
  font-size: 16px;
  line-height: 25px; /* Luft zwischen den drei Zeilen */
}

/* Block für das QR-Bild */
.QRBlock {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center; /* Vertikal zentriert */
}

.QRBlock > .Image {
  max-width: 100%; 
  height: auto; 
}
</style>
